<leaderboard-head class="row" [fields]="fields"></leaderboard-head>
<leaderboard-item class="row" *ngFor="let item of items; let n = index;"
                  [ngClass]="n % 2 ? 'odd' : 'even'"
                  [fields]="fields" [item]="item" [ranked]="ranked" [best]="best">
</leaderboard-item>
